import React from "react";
import Select from "react-select";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { toast } from "react-toastify";

import { RegisterQRConfirmationAnswer } from "../../../../home/helper/request.props.js";
import { PresenterQRConfirmationAnswer } from "../../../../home/presenter.js";
/*import Module from '../../../../utils/Render.js';*/
import FormHelper from "../../../../home/helper/form.js";
import toUTCtime from "../../../../helper/UTCtime";
import SelectQuery from "../../../../component/SelectQuery.js";

export default class ModalAcceptQRReassign extends React.Component {
  constructor() {
    super();
    this.initialState = {
      startDate: moment().add(1, "d"),
      minDate: moment().add(1, "d"),
      Site: "",
      Location: "",
      message: "",
      momentessage: "",
      dateDisabled: false,
      maxDate: null,
      modalData: null,
      currentLocation: null,
      chStartDate: null,
      nextReservation: null,
      MASTER_SITE: null,
      MASTER_LOCATION: null,
      LOCATION_FILTERED: []
    };
    this.state = Object.assign({}, this.initialState);

    this.isSiteSuggested = false;
    this.handleChange = this.handleChange.bind(this);
    this.handleMessageChange = this.handleMessageChange.bind(this);
  }

  handleChange(date) {
    this.setState({
      startDate: date
    });
  }

  handleMessageChange(evt) {
    this.setState({
      message: evt.target.value
    });
  }

  handleSiteChange(event) {
    // console.log('event')
    // console.log(event)
    var obj = {
      Site: event,
      clicked: true,
      // LOCATION_FILTERED: this.getLocationBySite(event.value),
      Location: ""
    };
    this.setState(obj, () => this._location.reload("", true));
  }

  handleLocationChange(event) {
    this.setState({
      Location: event,
      clicked: true
    });
  }

  acceptReassign() {
    // Set time to 2 (utc +0)
    let data = this.state;
    data.startDate._d.setHours(8);
    data.startDate._d.setMinutes(59);
    data.startDate._d.setSeconds(59);

    this.RequestParams = {
      ActiveDataModal: data.modalData,
      DueDateToUTCtime: toUTCtime(data.startDate._d),
      MyReservation: null,
      StartDate: null,
      Site: data.Site.value,
      Location: data.Location.value,
      Message: data.message
    };

    if (this.props.nextReservation) {
      data.chStartDate._d.setHours(9);
      data.chStartDate._d.setMinutes(0);
      data.chStartDate._d.setSeconds(0);

      this.RequestParams.StartDate = toUTCtime(data.chStartDate._d);
      this.RequestParams.MyReservation = data.nextReservation;
    }

    if (!FormHelper.ValidateFormAcceptReassign(this.RequestParams)) {
      return;
    }

    PresenterQRConfirmationAnswer(
      RegisterQRConfirmationAnswer(
        "accept",
        this,
        this.onRegisterConfirmationAnswerSuccsess.bind(this),
        this.onRegisterConfirmationAnswerFailed.bind(this)
      )
    );
  }

  onRegisterConfirmationAnswerSuccsess(params, response) {
    toast.success("Accept reasign success");
    this.props.onSuccess(response);
    this.props.closeModal();
  }

  onRegisterConfirmationAnswerFailed(params, response) {
    try {
      toast.error(response.data.detail);
    } catch (err) {}
  }

  getCurrentLocation(val) {
    this.setState({
      currentLocation: {
        latitude: val.coords.latitude,
        longitude: val.coords.longitude
      }
    });
  }

  getLocationBySite(site) {
    return this.state.MASTER_LOCATION.filter((val, key) => {
      return val.Site === site;
    });
  }

  generateLabel(list, mapping) {
    try {
      return list.map((val, key) => {
        if (mapping.label === "Username") {
          val.label = val.FirstName + " " + val.LastName;
        } else {
          val.label = val[mapping.label];
        }
        val.value = val[mapping.value];
        return val;
      });
    } catch (error) {
      if (list !== null) {
        let val = [];
        val.value = list[mapping.value];
        val.label = list[mapping.label];
        return val;
      }
      return null;
    }
  }

  renderSiteLocation() {
    if (this.props.nextReservation) {
      return null;
    } else {
      return (
        <div className="row">
          <div className="form-group col-sm-6">
            <label htmlFor="site">Site</label>
            <Select
              name="site"
              id="site"
              placeholder="Type Site"
              value={this.state.Site.value}
              options={this.state.MASTER_SITE}
              clearable={false}
              onChange={val => this.handleSiteChange(val)}
              disabled={this.state.dateDisabled}
            />
          </div>
          <div className="form-group col-sm-6">
            <label htmlFor="to">Location</label>
            <Select
              name="location"
              id="location"
              placeholder="Type Location"
              value={this.state.Location.value}
              options={this.state.LOCATION_FILTERED}
              clearable={false}
              onChange={val => this.handleLocationChange(val)}
              disabled={this.state.dateDisabled}
            />
          </div>
        </div>
      );
    }
  }

  renderDateField(next) {
    if (this.props.nextReservation) {
      return (
        <div className="row">
          <div className="form-group col-sm-6">
            <label htmlFor="">Original Start Date</label>
            <DatePicker
              id="dueDate"
              name="Location"
              className="form-control"
              dateFormat="YYYY-MM-DD"
              selected={moment(next.StartDate)}
              disabled={true}
            />
          </div>
          <div className="form-group col-sm-6">
            <label htmlFor="">Original Finish Date</label>
            <DatePicker
              id="dueDate"
              name="Location"
              className="form-control"
              dateFormat="YYYY-MM-DD"
              selected={moment(next.FinishDate)}
              disabled={true}
            />
          </div>

          <div className="form-group col-sm-6">
            <label htmlFor="">Changed Start Date</label>
            <DatePicker
              id="dueDate"
              name="Location"
              className="form-control"
              dateFormat="YYYY-MM-DD"
              selected={moment()}
              disabled={true}
            />
          </div>
          <div className="form-group col-sm-6">
            <label htmlFor="">Changed Finish Date</label>
            <DatePicker
              id="dueDate"
              name="Location"
              className="form-control"
              dateFormat="YYYY-MM-DD"
              selected={this.state.startDate}
              minDate={moment().add(1, "d")}
              maxDate={this.state.maxDate}
              onChange={this.handleChange}
            />
          </div>
        </div>
      );
    } else {
      let confirmType = this.state.Site.Type;
      if (confirmType === "storage" || confirmType === "maintenance") {
        return null;
      } else {
        return (
          <div className="row">
            <div className="form-group col-sm-12">
              <label htmlFor="">Set Due Date</label>
              <DatePicker
                id="dueDate"
                name="Location"
                className="form-control"
                dateFormat="YYYY-MM-DD"
                selected={this.state.startDate}
                // selected={this.state.modalData.ToReservation.FinishDate}
                minDate={this.state.minDate}
                // minDate={moment().add(1,'d')}
                maxDate={this.state.maxDate}
                onChange={this.handleChange}
                disabled={this.state.dateDisabled}
              />
            </div>
          </div>
        );
      }
    }
  }

  willMount() {
    const {
      NextReservation,
      MaxDay,
      ToReservation
    } = this.props.modalData.Asset;

    let maxDayAsset = MaxDay;
    let maxDay = moment().add(maxDayAsset, "d");

    this.setState({ maxDate: maxDay });

    if (ToReservation !== null) {
      this.setState({
        startDate: moment(ToReservation.FinishDate),
        dateDisabled: true,
        Site: ToReservation.Site,
        Location: ToReservation.Location
        // LOCATION_FILTERED : this.getLocationBySite(site.value),
      });
    } else {
      this.setState({
        dateDisabled: false,
        startDate: moment().add(1, "d")
        // maxDate      : maxDay
      });
      if (this.props.nextReservation) {
        const oriStartDate = moment(NextReservation.StartDate);
        const oriFinishDate = moment(NextReservation.FinishDate);
        const maxDate = maxDay < oriFinishDate ? maxDay : oriFinishDate;
        let startDate = moment().add(
          ((oriFinishDate - oriStartDate) / 1000 + 1) / 86400,
          "d"
        );
        startDate = startDate > maxDate ? maxDate : startDate;

        this.setState({
          chStartDate: moment(),
          startDate: startDate,
          maxDate: maxDate,
          dateDisabled: false,
          nextReservation: NextReservation.Alias,
          Site: NextReservation.Site,
          Location: NextReservation.Location
        });
      } else if (NextReservation) {
        const nextDate = moment(NextReservation.StartDate);
        if (maxDay < nextDate) {
          this.setState({ maxDate: maxDay });
        } else {
          this.setState({ maxDate: nextDate });
        }
      }
    }
  }

  willUnMount() {
    this.props.onClose();
    this.setState(this.initialState);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.modalData !== null) {
      if (nextProps.modalData.hasOwnProperty("Asset")) {
        nextState.modalData = nextProps.modalData;
      }
      if (nextProps.masterSite !== null || nextProps.masterLocation !== null) {
        //   	nextState.MASTER_SITE     = this.generateLabel(nextProps.masterSite, {value:'Alias', label:'Name'});
        //   	nextState.MASTER_LOCATION = this.generateLabel(nextProps.masterLocation, {value:'Alias', label:'Name'});
        //   	if (this.state.currentLocation !== null && !this.isSiteSuggested){
        // 	let nearestSite = Module.GetNearestSite(
        // 		nextProps.masterSite,
        // 		this.state.currentLocation
        // 	)
        // 	if (nearestSite !== null){
        // 		this.handleSiteChange(nearestSite)
        // 	}
        // 	this.isSiteSuggested = true
        // }
      }
      return true;
    }
    return false;
  }

  componentDidMount() {
    // navigator.geolocation.getCurrentPosition(this.getCurrentLocation.bind(this))
  }

  render() {
    const modalData = this.state.modalData;
    if (modalData === null) {
      return null;
    }
    return (
      <Modal
        isOpen={this.props.isOpen}
        onEnter={this.willMount.bind(this)}
        onExit={this.willUnMount.bind(this)}
        toggle={this.props.closeModal}
      >
        <ModalHeader toggle={this.props.closeModal}>
          Accept Reassign
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="form-group col-sm-6">
              <label htmlFor="from">Asset</label>
              <input
                type="text"
                className="form-control"
                id="from"
                value={modalData.Asset.Name}
                disabled
              />
            </div>
            <div className="form-group col-sm-6">
              <label htmlFor="from">From</label>
              <input
                type="text"
                className="form-control"
                id="from"
                value={
                  modalData.Asset.Owner.FirstName +
                  " " +
                  modalData.Asset.Owner.LastName
                }
                disabled
              />
            </div>
            <div className="form-group col-sm-6">
              <label htmlFor="site">Site</label>
              <SelectQuery
                name="Site"
                placeholder="Type Site"
                value={this.state.Site}
                urlKey="read-site-autocomplete"
                valKey="Alias"
                valLabel="Name"
                onChange={val => this.handleSiteChange(val)}
                initOption={this.state.Site}
                UserReducer={this.props.UserReducer}
                disabled={this.state.dateDisabled}
              />
            </div>
            <div className="form-group col-sm-6">
              <label htmlFor="to">Location</label>
              <SelectQuery
                name="Location"
                placeholder="Type Location"
                value={this.state.Location}
                urlKey="read-location-autocomplete"
                valKey="Alias"
                valLabel="Name"
                extra={"site=" + this.state.Site.value}
                initOption={this.state.Location}
                onRef={asd => (this._location = asd)}
                onChange={val => this.handleLocationChange(val)}
                UserReducer={this.props.UserReducer}
                disabled={this.state.dateDisabled}
              />
            </div>
          </div>
          {/*this.renderSiteLocation()*/}
          {this.renderDateField(modalData.Asset.NextReservation)}
          <div className="row">
            <div className="form-group col-sm-12">
              <label htmlFor="Message">Message</label>
              <textarea
                id="Message"
                name="Message"
                rows="5"
                className="form-control"
                placeholder="Enter Message Here"
                value={this.state.message}
                onChange={this.handleMessageChange}
              ></textarea>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button color="primary" onClick={() => this.acceptReassign()}>
            Accept
          </Button>{" "}
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/qrreader/helper/component/Modal/ModalAcceptQRReassign.js